exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#rulerHeader[data-v-b32a1496] {\n  box-sizing: border-box; /* ボーダー幅を無視 */\n  text-align: center;\n  letter-spacing: normal;\n  background-color: white;\n\n  border-top-style: none;\n  border-left-style: none;\n\n  border-bottom-style: solid;\n  border-bottom-width: 2px;\n  border-bottom-color: black;\n\n  border-right-style: solid;\n  border-right-width: 1px;\n  border-right-color: #aaaaaa;\n\n  margin-left: -1px;\n}\n.tlHeaderText[data-v-b32a1496] {\n  font-size: 4vw;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-b32a1496","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Mobile/timetable/SpRulerHeader.vue
// module id = 545
// module chunks = 0